<template>
  <div>
    You're authenticated now. Please close the window to return.
  </div>
</template>

<style lang="stylus" scoped>
  div
    display flex
    justify-content center
    align-items center
    flex-direction column
    margin-top 20%
  p
    text-align center
</style>

<script>
  import stopsLoading from '../lib/mixins/stopsLoading'

  export default {
    name: 'Callback',
    mixins: [
      stopsLoading
    ]
  }
</script>
